<div class="input-group input-group-sm">
  <input [id]="input.MainElementList[0].ID" type="text" class="form-control q-bo-input q-bo-wrap" aria-label="Small" attr.aria-describedby="{{input.MainElementList[0].ID}}-btn"
         [disabled]="input.MainElementList[0].Disabled"
         [(ngModel)]="this.input.MainElementList[0].Value"
         [ngClass]="setClass(input)">
  <div class="input-group-append">
    <button type="button" class="btn btn-outline-secondary q-bo-inputbtn q-bo-wrap"
            *ngIf="!input.MainElementList[0].Disabled"
            (click)="openTree()">
      <i class="fa fa-key"></i>
    </button>
  </div>
</div>

<div class="ackmodal" *ngIf="showList">
  <div class="container-fluid mt-4">
    <div class="row no-gutters">
      <div class="col-10">
        <div class="q-check">
          <input type="checkbox" id="checkAll" [checked]="allChecked" (change)="checkAll()" />
          <label for="checkAll">
            <span></span>Tout sélectionner
          </label>
        </div>
      </div>
      <div class="col-md-2">
        <i class="fas fa-save fa-lg q-c-main" (click)="save()"></i>
        <i class="fas fa-times fa-lg q-c-main ml-3" (click)="close()"></i>
      </div>
    </div>
    <div class="row no-gutters mt-2">
      <div class="col-md-12">
        <!-- offices level -->
        <ul style="list-style:none;" *ngIf="usersList && usersList.length > 0">
          <!--<li *ngFor="let group of usersList[0]?.Children">-->
          <li *ngFor="let group of usersList">
            <div *ngIf="group.IsVisible">
              <div class="q-check">
                <input type="checkbox" id="check_{{group.Value}}" [checked]="group.IsChecked" (change)="checkOffice(group)" />
                <label for="check_{{group.Value}}">
                  <span></span>{{group.Text}}
                </label>
                <span class="ml-2" *ngIf="group?.CollapseMode > 0">
                  <i class="far fa-folder ispointer ml-2 q-c-main" title="open" *ngIf="group.CollapseMode === 1" (click)="showUsers(group, $event)"></i>
                  <i class="far fa-folder-open ispointer ml-2 q-c-main" title="close" *ngIf="group.CollapseMode === 2" (click)="showUsers(group, $event)"></i>
                </span>
              </div>
              <!--users level-->
              <ul style="list-style:none;">
                <li *ngFor="let user of group.Children">

                  <div class="q-check" *ngIf="user.IsVisible" title="{{user.Value}}">
                    <input type="checkbox" id="check_{{user.Value}}" [checked]="user.IsChecked" (change)="checkUser(user, group)" />
                    <label for="check_{{user.Value}}">
                      <span></span>{{user.Text}} <i style="font-size:.8rem;">({{user.Params}})</i>
                    </label>
                  </div>

                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
